import { Moon, Sun } from "lucide-react";
import { colors } from "../design-system";
import { resolveTheme, usePreferencesStore } from "../stores/preferencesStore";

/**
 * Interrupteur de thème — UNE icône à la fois, dans la barre supérieure.
 *
 * ## L'icône annonce la DESTINATION, pas l'état
 * En mode clair on affiche la lune : « appuyer assombrit ». C'est la convention
 * de GitHub, de Vercel et de la plupart des sites — et c'est la lecture utile,
 * puisqu'un bouton sert à faire quelque chose. L'état courant, lui, se voit
 * déjà : l'écran entier le montre.
 *
 * ## Trois valeurs de préférence, deux positions
 * La préférence connaît `light`, `dark` et `system`. `system` n'a pas d'icône
 * propre : on part du thème RÉELLEMENT affiché pour aller à son opposé.
 * Appuyer alors que l'appareil est en sombre éclaire donc l'app, et ne
 * l'assombrit jamais davantage. Le premier appui fige un choix explicite, qui
 * ne suivra plus l'appareil.
 */
export function ThemeToggle({ className }: { className?: string }) {
  const theme = usePreferencesStore((s) => s.theme);
  const toggleTheme = usePreferencesStore((s) => s.toggleTheme);

  const goingDark = resolveTheme(theme) === "light";

  return (
    <button
      type="button"
      onClick={toggleTheme}
      // Le libellé décrit L'ACTION, cohérent avec l'icône affichée. `title`
      // porte la même chose à la souris, où rien n'explique un bouton sans mot.
      aria-label={goingDark ? "Passer en mode sombre" : "Passer en mode clair"}
      title={goingDark ? "Mode sombre" : "Mode clair"}
      className={[
        "flex h-11 w-11 shrink-0 items-center justify-center rounded-full transition-colors hover:bg-gray-50",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {goingDark ? (
        <Moon size={20} color={colors.navy800} aria-hidden />
      ) : (
        <Sun size={20} color={colors.navy800} aria-hidden />
      )}
    </button>
  );
}
